// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* sidebar.css */

.sidebar {
  width: 300px;
  height: 90vh;
  top: 8em;
  right: 0;
  background-color: #000000; /* Dark navy blue for a classy look */
  color: #ecf0f1; /* Light text color for contrast */
  display: flex;
  flex-direction: column;
  position: fixed;
  z-index: 1000;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Subtle shadow for depth */
  /* Scrollable content if it overflows */
  transition: transform 0.3s ease-in-out; /* Smooth transition for show/hide */
}

.sidebar-content {
  margin-top: 2em;
  padding: 20px;
  flex-grow: 1;
  font-family: "Lato", sans-serif; /* Modern font choice */
}

.sidebar-footer {
  padding: 10px 20px;
  background-color: #34495e; /* Slightly darker footer */
  text-align: center;
  border-top: 1px solid #1a252f;
}

/* Scoped to .sidebar — global li/button rules were affecting MUI MenuItem (<li>) everywhere */
.sidebar ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.sidebar li {
  margin-bottom: 20px;
  transition: transform 0.2s ease-in-out; /* Animation for hover effect */
  animation: fadeIn 0.5s ease-in-out;
}

.sidebar li:hover {
  transform: translateX(10px); /* Subtle sliding animation */
}

.sidebar button {
  background-color: #242b30; /* Classy blue */
  color: #ecf0f1;
  border: none;
  border-radius: 8px;
  padding: 10px 15px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
  font-family: "Roboto", sans-serif;
}

.sidebar button:hover {
  background-color: #474848; /* Slightly lighter blue on hover */
  transform: scale(1.05); /* Subtle zoom effect */
}

.sidebar button:disabled {
  background-color: #7f8c8d; /* Grey for disabled state */
  cursor: not-allowed;
}

.sidebar label {
  font-weight: 600;
  margin-bottom: 8px;
  display: block;
  font-size: 14px;
  color: #bdc3c7; /* Subtle light grey for labels */
}

.sidebar select {
  width: 100%;
  padding: 10px;
  background-color: #34495e; /* Dark dropdown background */
  color: #ecf0f1;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  font-family: "Roboto", sans-serif;
}

.sidebar select:hover,
.sidebar select:focus {
  background-color: #3b5998; /* Highlighted on focus */
}

.radius-dropdown {
  margin-top: 10px;
}

.sidebar p {
  margin: 10px 0;
  font-size: 14px;
  color: #ecf0f1;
  line-height: 1.6;
}

.fa-icon {
  margin-right: 10px;
  font-size: 16px;
}

.sidebar button.active {
  background-color: #27ae60; /* Elegant green for active buttons */
  color: white;
}

.sidebar-footer a {
  color: #ecf0f1;
  text-decoration: none;
  font-size: 12px;
  transition: color 0.3s ease;
}

.sidebar-footer a:hover {
  color: #bdc3c7; /* Softer light grey on hover */
}

/* Scrollbar styling */
.sidebar ::-webkit-scrollbar {
  width: 8px;
}

.sidebar ::-webkit-scrollbar-thumb {
  background-color: #7f8c8d;
  border-radius: 10px;
}

.sidebar ::-webkit-scrollbar-thumb:hover {
  background-color: #95a5a6;
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.sidebar-content ul li {
  position: relative;
}

.sidebar-content ul li::before {
  content: "";
  position: absolute;
  height: 100%;
  width: 3px;
  background: linear-gradient(180deg, #3498db, #27ae60);
  left: 0;
  top: 0;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.sidebar-content ul li:hover::before {
  opacity: 1;
}
/* Styled marker list */
.marker-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 15px; /* Spacing between cards */
}

.marker-list li {
  background-color: #ecf0f1; /* Light background for cards */
  border: 1px solid #bdc3c7; /* Subtle border */
  border-radius: 10px; /* Rounded corners */
  padding: 15px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  font-family: "Roboto", sans-serif;
}

.marker-list li:hover {
  transform: translateY(-5px); /* Lift effect on hover */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Elevated shadow */
}

.marker-button {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background-color: transparent;
  border: none;
  color: #34495e; /* Text color */
  cursor: pointer;
  text-align: left;
  padding: 0;
  font-size: 14px;
  line-height: 1.6;
}

.marker-button:hover {
  color: #2980b9; /* Highlight color on hover */
}

.marker-title {
  font-weight: bold;
  font-size: 16px;
  color: #2c3e50;
  margin-bottom: 5px;
}

.marker-info {
  font-size: 14px;
  color: #7f8c8d;
}

.marker-value {
  font-weight: bold;
  color: #2980b9; /* Highlight important values */
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 80%;
  height: 100%;
  background-color: rgba(47, 42, 42, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  overflow: hidden;
}

body.modal-open {
  overflow: hidden; /* Prevent page scroll when modal is active */
}

.modal-content {
  background-color: rgb(0, 0, 0);
  padding: 20px;
  border-radius: 8px;
  width: 70%; /* Make the modal take up the full width of the screen */
  height: 100%; /* Make the modal take up the full height of the screen */
  overflow-y: auto; /* Ensure scroll if content overflows */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  justify-content: center; /* Vertically center the content inside the modal */
  align-items: center; /* Horizontally center the content */
}

.marker-item {
  padding: 10px;
  border-bottom: 1px solid #292828;
}

.marker-item h3 {
  color: #313a41;
}
`, "",{"version":3,"sources":["webpack://./src/sidebar.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB;EACE,YAAY;EACZ,YAAY;EACZ,QAAQ;EACR,QAAQ;EACR,yBAAyB,EAAE,qCAAqC;EAChE,cAAc,EAAE,kCAAkC;EAClD,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,wCAAwC,EAAE,4BAA4B;EACtE,uCAAuC;EACvC,sCAAsC,EAAE,oCAAoC;AAC9E;;AAEA;EACE,eAAe;EACf,aAAa;EACb,YAAY;EACZ,+BAA+B,EAAE,uBAAuB;AAC1D;;AAEA;EACE,kBAAkB;EAClB,yBAAyB,EAAE,2BAA2B;EACtD,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA,8FAA8F;AAC9F;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,sCAAsC,EAAE,+BAA+B;EACvE,kCAAkC;AACpC;;AAEA;EACE,2BAA2B,EAAE,6BAA6B;AAC5D;;AAEA;EACE,yBAAyB,EAAE,gBAAgB;EAC3C,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2DAA2D;EAC3D,iCAAiC;AACnC;;AAEA;EACE,yBAAyB,EAAE,mCAAmC;EAC9D,sBAAsB,EAAE,uBAAuB;AACjD;;AAEA;EACE,yBAAyB,EAAE,4BAA4B;EACvD,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,cAAc,EAAE,iCAAiC;AACnD;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB,EAAE,6BAA6B;EACxD,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,iCAAiC;AACnC;;AAEA;;EAEE,yBAAyB,EAAE,yBAAyB;AACtD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB,EAAE,qCAAqC;EAChE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc,EAAE,+BAA+B;AACjD;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,qDAAqD;EACrD,OAAO;EACP,MAAM;EACN,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;AACA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAE,0BAA0B;AACvC;;AAEA;EACE,yBAAyB,EAAE,+BAA+B;EAC1D,yBAAyB,EAAE,kBAAkB;EAC7C,mBAAmB,EAAE,oBAAoB;EACzC,aAAa;EACb,qDAAqD;EACrD,wCAAwC;EACxC,iCAAiC;AACnC;;AAEA;EACE,2BAA2B,EAAE,yBAAyB;EACtD,wCAAwC,EAAE,oBAAoB;AAChE;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;EACZ,cAAc,EAAE,eAAe;EAC/B,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc,EAAE,6BAA6B;AAC/C;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc,EAAE,+BAA+B;AACjD;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,UAAU;EACV,YAAY;EACZ,uCAAuC;EACvC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB,EAAE,6CAA6C;AACjE;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,UAAU,EAAE,wDAAwD;EACpE,YAAY,EAAE,yDAAyD;EACvE,gBAAgB,EAAE,uCAAuC;EACzD,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,uBAAuB,EAAE,mDAAmD;EAC5E,mBAAmB,EAAE,oCAAoC;AAC3D;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* sidebar.css */\n\n.sidebar {\n  width: 300px;\n  height: 90vh;\n  top: 8em;\n  right: 0;\n  background-color: #000000; /* Dark navy blue for a classy look */\n  color: #ecf0f1; /* Light text color for contrast */\n  display: flex;\n  flex-direction: column;\n  position: fixed;\n  z-index: 1000;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Subtle shadow for depth */\n  /* Scrollable content if it overflows */\n  transition: transform 0.3s ease-in-out; /* Smooth transition for show/hide */\n}\n\n.sidebar-content {\n  margin-top: 2em;\n  padding: 20px;\n  flex-grow: 1;\n  font-family: \"Lato\", sans-serif; /* Modern font choice */\n}\n\n.sidebar-footer {\n  padding: 10px 20px;\n  background-color: #34495e; /* Slightly darker footer */\n  text-align: center;\n  border-top: 1px solid #1a252f;\n}\n\n/* Scoped to .sidebar — global li/button rules were affecting MUI MenuItem (<li>) everywhere */\n.sidebar ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.sidebar li {\n  margin-bottom: 20px;\n  transition: transform 0.2s ease-in-out; /* Animation for hover effect */\n  animation: fadeIn 0.5s ease-in-out;\n}\n\n.sidebar li:hover {\n  transform: translateX(10px); /* Subtle sliding animation */\n}\n\n.sidebar button {\n  background-color: #242b30; /* Classy blue */\n  color: #ecf0f1;\n  border: none;\n  border-radius: 8px;\n  padding: 10px 15px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background-color 0.3s ease, transform 0.2s ease;\n  font-family: \"Roboto\", sans-serif;\n}\n\n.sidebar button:hover {\n  background-color: #474848; /* Slightly lighter blue on hover */\n  transform: scale(1.05); /* Subtle zoom effect */\n}\n\n.sidebar button:disabled {\n  background-color: #7f8c8d; /* Grey for disabled state */\n  cursor: not-allowed;\n}\n\n.sidebar label {\n  font-weight: 600;\n  margin-bottom: 8px;\n  display: block;\n  font-size: 14px;\n  color: #bdc3c7; /* Subtle light grey for labels */\n}\n\n.sidebar select {\n  width: 100%;\n  padding: 10px;\n  background-color: #34495e; /* Dark dropdown background */\n  color: #ecf0f1;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  outline: none;\n  font-family: \"Roboto\", sans-serif;\n}\n\n.sidebar select:hover,\n.sidebar select:focus {\n  background-color: #3b5998; /* Highlighted on focus */\n}\n\n.radius-dropdown {\n  margin-top: 10px;\n}\n\n.sidebar p {\n  margin: 10px 0;\n  font-size: 14px;\n  color: #ecf0f1;\n  line-height: 1.6;\n}\n\n.fa-icon {\n  margin-right: 10px;\n  font-size: 16px;\n}\n\n.sidebar button.active {\n  background-color: #27ae60; /* Elegant green for active buttons */\n  color: white;\n}\n\n.sidebar-footer a {\n  color: #ecf0f1;\n  text-decoration: none;\n  font-size: 12px;\n  transition: color 0.3s ease;\n}\n\n.sidebar-footer a:hover {\n  color: #bdc3c7; /* Softer light grey on hover */\n}\n\n/* Scrollbar styling */\n.sidebar ::-webkit-scrollbar {\n  width: 8px;\n}\n\n.sidebar ::-webkit-scrollbar-thumb {\n  background-color: #7f8c8d;\n  border-radius: 10px;\n}\n\n.sidebar ::-webkit-scrollbar-thumb:hover {\n  background-color: #95a5a6;\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.sidebar-content ul li {\n  position: relative;\n}\n\n.sidebar-content ul li::before {\n  content: \"\";\n  position: absolute;\n  height: 100%;\n  width: 3px;\n  background: linear-gradient(180deg, #3498db, #27ae60);\n  left: 0;\n  top: 0;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.sidebar-content ul li:hover::before {\n  opacity: 1;\n}\n/* Styled marker list */\n.marker-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 15px; /* Spacing between cards */\n}\n\n.marker-list li {\n  background-color: #ecf0f1; /* Light background for cards */\n  border: 1px solid #bdc3c7; /* Subtle border */\n  border-radius: 10px; /* Rounded corners */\n  padding: 15px;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  font-family: \"Roboto\", sans-serif;\n}\n\n.marker-list li:hover {\n  transform: translateY(-5px); /* Lift effect on hover */\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Elevated shadow */\n}\n\n.marker-button {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  background-color: transparent;\n  border: none;\n  color: #34495e; /* Text color */\n  cursor: pointer;\n  text-align: left;\n  padding: 0;\n  font-size: 14px;\n  line-height: 1.6;\n}\n\n.marker-button:hover {\n  color: #2980b9; /* Highlight color on hover */\n}\n\n.marker-title {\n  font-weight: bold;\n  font-size: 16px;\n  color: #2c3e50;\n  margin-bottom: 5px;\n}\n\n.marker-info {\n  font-size: 14px;\n  color: #7f8c8d;\n}\n\n.marker-value {\n  font-weight: bold;\n  color: #2980b9; /* Highlight important values */\n}\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 80%;\n  height: 100%;\n  background-color: rgba(47, 42, 42, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  overflow: hidden;\n}\n\nbody.modal-open {\n  overflow: hidden; /* Prevent page scroll when modal is active */\n}\n\n.modal-content {\n  background-color: rgb(0, 0, 0);\n  padding: 20px;\n  border-radius: 8px;\n  width: 70%; /* Make the modal take up the full width of the screen */\n  height: 100%; /* Make the modal take up the full height of the screen */\n  overflow-y: auto; /* Ensure scroll if content overflows */\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n  display: flex;\n  flex-direction: column;\n  justify-content: center; /* Vertically center the content inside the modal */\n  align-items: center; /* Horizontally center the content */\n}\n\n.marker-item {\n  padding: 10px;\n  border-bottom: 1px solid #292828;\n}\n\n.marker-item h3 {\n  color: #313a41;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
